import styled from "styled-components";

const Sidebar = styled.div`
    max-width: 22rem;
    width: 100%;
    overflow: auto;
    height: calc(100vh - 4.5rem);
    position: fixed;
    left: 0;
    background-color: ${props => props.theme.colors.white(1)};
`;

export default Sidebar;
